module.exports = __webpack_public_path__ + "logo_full-5c51cffe1fcb8225ae02400d6a7e7077.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/mailer/logo_full.png
// module id = 278
// module chunks = 70